import React from "react";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/home/Home";
import BlogDetails from "./pages/blogDetails/BlogDetails";
import BlogList from "./pages/blogList/BlogList";
import Aboutus from "./pages/Aboutus";
import Features from "./pages/Features";
import Howitwork from "./pages/Howitwork";
import Faq from "./pages/Faq";
import Pricing from "./pages/pricing";
import Contactus from "./pages/Contactus";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsAndConditions from "./pages/TermsAndConditions";

const RoutesComponent = () => (
  <Router>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/blog/:slug" element={<BlogDetails />} />
      <Route path="/bloglist" element={<BlogList />} />
      <Route path="/aboutus" element={<Aboutus />} />
      <Route path="/contact-us" element={<Contactus />} />
      <Route path="/features" element={<Features />} />
      <Route path="/how-it-works" element={<Howitwork />} />
      <Route path="/faq" element={<Faq />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
    </Routes>
  </Router>
);

export default RoutesComponent;
